<template>
  <el-dialog
          title=""
          :visible.sync="receiveDialogVisible"
          :show-close="false"
          :close-on-click-modal="false"
          custom-class="receive-dialog"
          center
          width="360px">
    <p class="title">加入福星购，享受内部价</p>
    <p></p>
    <div style="text-align: center;">
      <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/operationalActivityDialog_fxg.jpg" alt="">
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" style="margin-left: 120px;padding: 7px 20px;">关闭</el-button>
      <div class="pull-right" style="padding-top: 4px; padding-left: 10px">
        <el-checkbox v-model="checked">以后不再弹出</el-checkbox>
      </div>

    </span>
  </el-dialog>
</template>
<script>
  export default {
    props: {
      receiveDialogVisible: {
        type: Boolean,
        default: false
      },
      userInfo: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        checked: false
      }
    },
    created () {
    },
    methods:{
      closeDialog () {
        if (this.checked) {
          this.$axios.post('/onelink.mdata.main.api/web/operateFosunShopping')
        }
        this.$emit('closeReceiveDialog')
      }

    }
  }
</script>
<style lang="stylus">
  .receive-dialog {
    .el-dialog__header{
      padding: 0;
    }
    &.el-dialog--center{
      .el-dialog__body{
        padding: 25px 30px 10px;
        color: #303133;
      }
    }
    .title{
      font-size: 18px;
      text-align: center;
    }
    .el-dialog__footer {
      text-align: center;
      /*padding-right: 48px;*/
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/checkinReceiveDialog.vue